import './addVisitRemarksSection.scss'
import classnames from 'classnames'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { ARE_YOU_SURE_DELETE_REMARK_TEXT, DELETE_REMARK_TEXT, VISIT_REMARKS_TITLE } from '../../../../utils/constants'
import visitRemarksTileIcon from '../../../../images/common/visitRemarksTileIcon.png'
import { ChartSection } from '../../../patient-chart-page/components/chart-section/ChartSection'
import { AddRemark } from '../AddRemark/AddRemark'
import { VisitRemarksContent } from '../../../../components/VisitRemarksContent/VisitRemarksContent'
import {
  createUpcomingVisitRemark,
  getUpcomingVisitRemarks,
  removeUpcomingVisitRemark,
  updateUpcomingVisitRemark,
} from '../../../../store/charts/ChartsThunk'
import { DeleteAlertPopUp } from '../../../patient-chart-page/components/delete-alert-popup/DeleteAlertPopUp'
import { getTimeZones, parseTimeZone } from '../../../../utils/common'

const classes = {
  chartSection: 'remarks-section-wrapper',
  chartSectionWithNewAlerForm: 'remarks-section-wrapper-with-new-remarks-form',
  chartSectionSmaller: 'remarks-section--smaller',
  chartSectionSmallerEmpty: 'remarks-section--smaller-empty',
  chartSectionSmallerWithNewAlerForm: 'remarks-section-wrapper-with-new-alert-form--smaller',
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const AddVisitRemarksSection = ({ userTimeZone, visitId }) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const remarksObj = useSelector((state) => state.chartsReducer.remarks)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.chartsReducer.loading)
  const remarks = useMemo(() => remarksObj?.[visitId] || {}, [remarksObj, visitId])

  const [isAddRemarkOpen, setAddRemarkOpen] = useState(false)
  const [editRemarkId, setEditRemarkId] = useState(null)
  const [editRemark, setEditRemark] = useState('')
  const [deleteRemarkId, setDeleteRemarkId] = useState(null)
  const [isOpenRemarksFirstTime, setIsOpenRemarksFirstTime] = useState(true)
  const [textareaValue, setTextareaValue] = useState('')

  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  const parsedAdminTimeZoneAbbr =
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    parseTimezone(userTimeZone)?.label ?? parseTimezone(parseTimeZone(userTimeZone ?? ''))?.label

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onTextareaValueChange = useCallback((event) => {
    setTextareaValue(event.target.value)
  }, [])

  const [isCollapsed, setIsCollapsed] = useState(true)

  const getVisitRemarks = useCallback(() => {
    if (visitId && isOpenRemarksFirstTime) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getUpcomingVisitRemarks(visitId))
      setIsOpenRemarksFirstTime(false)
    }
  }, [dispatch, isOpenRemarksFirstTime, visitId])

  const setIsCollapsedRemarksSection = useCallback(() => {
    getVisitRemarks()
    setIsCollapsed((prev) => !prev)
  }, [getVisitRemarks])

  const onOpenAddRemark = useCallback(() => {
    setAddRemarkOpen(true)
    getVisitRemarks()
    setIsCollapsed(false)
  }, [getVisitRemarks])

  useEffect(() => {
    if (editRemarkId) {
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      const remarkForEdit = remarks.remarksList.find(({ RemarkId }) => RemarkId === editRemarkId)
      setEditRemark(remarkForEdit)
    }
  }, [editRemarkId, remarks])

  useEffect(() => {
    if (editRemark) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setTextareaValue(editRemark.Message)
      setAddRemarkOpen(true)
    }
  }, [editRemark])

  const onCancelAddRemark = useCallback(() => {
    setAddRemarkOpen(false)
    setTextareaValue('')
    setEditRemark('')
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEditRemarkId('')
  }, [])

  const addNewRemark = useCallback(() => {
    if (textareaValue.trim()) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        createUpcomingVisitRemark({
          visitId,
          Message: textareaValue.trim().replaceAll('<br>', '\n'),
        }),
      )
    }
    setTextareaValue('')
    setAddRemarkOpen(false)
  }, [dispatch, textareaValue, visitId])
  const onEditRemark = useCallback(() => {
    if (textareaValue.trim()) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        updateUpcomingVisitRemark({
          visitId,
          remarkId: editRemarkId,
          Message: textareaValue.trim().replaceAll('<br>', '\n'),
        }),
      )
    }
    setTextareaValue('')
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEditRemarkId('')
    setEditRemark('')
    setAddRemarkOpen(false)
  }, [dispatch, editRemarkId, textareaValue, visitId])

  const onRemoveRemark = useCallback(() => {
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      removeUpcomingVisitRemark({
        visitId,
        remarkId: deleteRemarkId,
      }),
    )
  }, [deleteRemarkId, dispatch, visitId])

  const onDeleteRemarkAction = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (isShouldBeRemoved) => {
      if (isShouldBeRemoved) {
        onRemoveRemark()
      }
      setDeleteRemarkId(null)
    },
    [onRemoveRemark],
  )

  const emptyRemarks =
    !isAddRemarkOpen && !loading ? <span className='chart-card-no-records'>No visit remarks</span> : null

  const sortedRemarks = useMemo(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    () => remarks.remarksList?.sort((a, b) => new Date(b.DateTime) - new Date(a.DateTime)),
    [remarks.remarksList],
  )

  return (
    <>
      {deleteRemarkId ?
        <div className='alerts-section-delete-pop-up-container'>
          <DeleteAlertPopUp
            popUpTitle={DELETE_REMARK_TEXT}
            popUpBodyText={ARE_YOU_SURE_DELETE_REMARK_TEXT}
            setPopUpOpened={onDeleteRemarkAction}
          />
        </div>
      : null}

      {/*
       // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
      <ChartSection
        id='add-visit-remarks-section'
        className={classnames('add-visit-remarks-section-upcoming-visit-details', {
          [classes.chartSection]: !isCollapsed,
          [classes.chartSectionSmaller]: !isCollapsed && remarks?.remarksList?.length < 3,
          [classes.chartSectionSmallerEmpty]: !isCollapsed && !remarks?.remarksList?.length,
          [classes.chartSectionWithNewAlerForm]: !isCollapsed && isAddRemarkOpen,
          [classes.chartSectionSmallerWithNewAlerForm]:
            !isCollapsed && isAddRemarkOpen && remarks?.remarksList?.length < 3,
        })}
        title={VISIT_REMARKS_TITLE}
        icon={visitRemarksTileIcon}
        iconAltText='visit remarks'
        setIsCollapsed={setIsCollapsedRemarksSection}
        clickButtonAction={onOpenAddRemark}
        isCollapsed={isCollapsed}
        userTimeZone={userTimeZone}
        isWithoutLastUpdated
        isShowEmptyContent={isAddRemarkOpen ? false : !remarks?.remarksList?.length}
        isShouldScrollUpContent
        isShowButton={!isAddRemarkOpen && !isCollapsed}
        isNewButton>
        {isAddRemarkOpen ?
          <AddRemark
            remarkValue={textareaValue}
            isEditMode={!!editRemarkId}
            onChange={onTextareaValueChange}
            onRemarkAdd={addNewRemark}
            onEditRemark={onEditRemark}
            onCancel={onCancelAddRemark}
          />
        : null}
        {sortedRemarks?.length ?
          <VisitRemarksContent
            setEditRemarkId={setEditRemarkId}
            setDeleteRemarkId={setDeleteRemarkId}
            isFormOpened={isAddRemarkOpen}
            userTimeZone={userTimeZone}
            remarks={remarks}
            userTimeZoneAbbr={parsedAdminTimeZoneAbbr}
          />
        : emptyRemarks}
      </ChartSection>
    </>
  )
}

export default AddVisitRemarksSection
